module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tabs",
    class: 'tab-active--' + _vm.activeTab
  }, _vm._l((_vm.tabs), function(tab) {
    return (_vm.isContentTab(tab.index)) ? _c('a', {
      class: {
        'is-active': tab.index == _vm.activeTab || tab.index == 1 && _vm.activeTab == 0 && !_vm.isMobile
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.setActiveTab(tab.index)
        }
      }
    }, [_vm._v("\n\n            " + _vm._s(tab.title) + "\n\n            "), (tab.count) ? _c('em', [_vm._v(_vm._s(tab.count))]) : _vm._e()]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-details"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a95a55d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Tabs.vue
// module id = 577
// module chunks = 225